// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"e06899e1","461":"46f400f7","787":"f9e631f3"}[chunkId] + ".chunk.js";
};